import { render, staticRenderFns } from "./ProcInstFinished.vue?vue&type=template&id=3607d784&"
import script from "./ProcInstFinished.vue?vue&type=script&lang=js&"
export * from "./ProcInstFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports